import { Chip } from "@mui/material";

import {
  ClientStatus,
  type ClientStatus as ClientStatusType,
} from "Infrastructure/Api/Api";
import { useAppNavigate } from "Infrastructure/Routing/useAppNavigate";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import {
  type BlDetailSectionItem,
  DetailSection,
} from "Shared/Sections/DetailSection";

interface PartnerClient {
  clientID: string;
  companyName: string;
  status: ClientStatusType;
}

interface PartnerClientsProps {
  clients: PartnerClient[];
}

export const PartnerClients = ({
  clients,
}: PartnerClientsProps): React.ReactNode => {
  const { t } = useResource();
  const navigate = useAppNavigate();

  const items: BlDetailSectionItem[] = clients.map((client) => {
    const isInactive = client.status === ClientStatus.Inactive;

    return {
      id: client.clientID,
      label: {
        text: client.companyName,
        onClick: () => navigate(AppRouting.ClientDetail.path(client.clientID)),
      },
      endAdornment: isInactive ? (
        <Chip
          label={t(Resources.Common.StatusInactive)}
          size="small"
          sx={(theme) => ({
            backgroundColor: theme.colors.backgroundInput,
            color: theme.palette.text.disabled,
            fontSize: "12px",
          })}
        />
      ) : undefined,
    };
  });

  return (
    <DetailSection
      title={t(Resources.Partners.PartnerDetail.Clients)}
      items={items}
      emptyMessage={t(Resources.Partners.PartnerDetail.NoClients)}
    />
  );
};
